import { get, post } from '@/lib/http';
import { endpoints } from './endpoints';
import type { AuthUser, ChangePasswordRequest, LoginRequest, LoginResponse } from '@/types';

export const authApi = {
  login: (body: LoginRequest) => post<LoginResponse, LoginRequest>(endpoints.auth.login, body),

  logout: () => post<void>(endpoints.auth.logout),

  me: () => get<AuthUser>(endpoints.auth.me),

  changePassword: (body: ChangePasswordRequest) =>
    post<void, ChangePasswordRequest>(endpoints.auth.changePassword, body),
};
